import CheckOutForm from ".";

export const checkoutFormRoute = () => [
  {
    path: "/:lang/user/check-out-form/:eventId",
    title: "Form",
    layout: "frontUserInner",
    routeType: "organization",
    component: CheckOutForm,
  },
];
